export const CategoryData = {
   '1': [ 'MS Dhoni', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/1.png' ],
   '2': [ 'Ravindra Jadeja', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/9.png' ],
   '3': [ 'Moeen Ali', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/1735.png' ],
   '4': [ 'Deepak Chahar', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/140.png' ],
   '5': [ 'Mitchell Santner', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/1903.png' ],

   '6': [ 'Rohit Sharma', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/107.png' ],
   '7': [ 'Suryakumar Yadav', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/108.png' ],
   '8': [ 'Ishan Kishan', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/2975.png' ],
   '9': [ 'Jasprit Bumrah', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/1124.png' ],
   '10': [ 'Kieron Pollard', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/210.png' ],

   '11': [ 'Hardik Pandya', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/2740.png' ],
   '12': [ 'David Miller', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/187.png' ],
   '13': [ 'Shubman Gill', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/3761.png' ],
   '14': [ 'Rashid Khan', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/2885.png' ],
   '15': [ 'Mohammed Shami', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/94.png' ],

   '16': [ 'Sanju Samson', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/258.png' ],
   '17': [ 'Jos Buttler', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/509.png' ],
   '18': [ 'Devdutt Padikkal', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/5430.png' ],
   '19': [ 'Trent Boult', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/969.png' ],
   '20': [ 'Yuzi Chahal', 'https://assets.iplt20.com/ipl/IPLHeadshot2022/111.png' ]
}